export var responseToState = function responseToState(items, value, text) {
    if (!items) return [];

    return items.map(function (t) {
        return {
            value: t[value], text: t[text]
        };
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/mappers/response-to-state.js
// module id = ./src/mappers/response-to-state.js
// module chunks = 34